import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'drawer',
  standalone: false,
  template: `
  <div class="drawer" [class.hidden]="hidden">
    <div class="drawer-backdrop" (click)="onClose($event)"></div>
    <div class="drawer-content" [@slideInOut]="animationState" (@slideInOut.done)="onAnimationEnd($event)">
        <h1 class="h5" (click)="onClose($event)">
          {{ title }}<span>&nbsp;</span>
          <button type="button" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
        </h1>
        <div *ngIf="!this.hidden">
            <ng-content ></ng-content>
        </div>
    </div>
  </div>
  `,
  animations: [
    trigger('slideInOut', [
      state('open', style({transform: ''})), // when open, don't apply transform as that breaks
                                                           // the fixed positioning of fly-to button
      state('close', style({transform: 'translateY(100%)'})),
      transition('close => open', [
        animate('300ms ease-in-out', style({transform: 'translateY(0%)'}))
      ]),
      transition('open => close', [
        animate('300ms ease-in-out', style({transform: 'translateY(100%)'}))
      ])
    ])
  ]
})

export class DrawerComponent implements OnInit, OnChanges {
  @Input() open: boolean;
  @Input() title: string = "";
  @Output() close = new EventEmitter<Event>();
  @Output() afterClose = new EventEmitter<void>();

  hidden: boolean = false;
  animationState: string = 'close';

  ngOnInit() {
    this.hidden = !this.open;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.animationState = (this.open) ? 'open' : 'close';
    if (this.open) {this.hidden = false}
  }

  onClose($event) {
    this.close.emit($event);
  }

  onAnimationEnd($event) {
    this.hidden = ($event.toState == 'close');
    if (this.hidden) {
      this.afterClose.emit();
    }
  }
}
